<template>
    <span class="bg-primary rounded-full p-1 inline-flex items-center">
        <font-awesome-icon class="text-white mx-2" :icon="['fas', icon]" size="lg"></font-awesome-icon>

        <span class="rounded-full bg-white text-dark font-bold text-xl w-8 h-8 flex items-center justify-center">
            {{ rating }}
        </span>
    </span>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
    components: {FontAwesomeIcon},
    props: {
        type: String,
        rating: [Number, String]
    },
    computed: {
        icon() {
            switch (this.type) {
                case 'fuel': return 'gas-pump';
                case 'wet': return 'cloud-showers';
                case 'noise': return 'volume';
            }
        }
    }
}
</script>

<style scoped>

</style>
